import {useNavigate} from 'react-router-dom';
import Illustration from '@cvent/carina/components/Illustration';
import {Button} from '@cvent/carina/components/Button';

export function NotFound() {
  const navigate = useNavigate();

  function handleClick() {
    return navigate('/new/login');
  }

  return (
    <div className="px-4 md:px-0 h-full max-w-lg mx-auto flex flex-col justify-center items-center">
      <Illustration
        aria-hidden
        className="size-[375px]"
        name="error"
        pack="carina"
      />
      <div className="leading-4 flex flex-col items-center">
        <div className="text-body-lg font-bold mb-2">Page Not Found</div>
        <div className="text-center mb-4 text-body-md text-soft">
          The page may have been moved or deleted. Check the URL and try again.
        </div>
        <div className="mb-4">
          <Button text="Go back" onClick={handleClick} appearance="filled" />
        </div>
      </div>
    </div>
  );
}
